export default "__VITE_ASSET__DYHi0xHB__"